export const ROLE_PICKER_WIDTH = 360;

export const MENU_MAX_HEIGHT = 300; // max height for the picker's dropdown menu

export const ROLE_PICKER_MENU_MIN_WIDTH = 320;
export const ROLE_PICKER_MENU_MAX_WIDTH = 360;

export const ROLE_PICKER_SUBMENU_MIN_WIDTH = 320;
export const ROLE_PICKER_SUBMENU_MAX_WIDTH = 360;

export const ROLE_PICKER_MAX_MENU_WIDTH = ROLE_PICKER_MENU_MAX_WIDTH + ROLE_PICKER_SUBMENU_MAX_WIDTH;
